import { useSignals } from '@preact/signals-react/runtime';
import type { ComponentType, FC } from 'react';

export function observer<P extends object>(Comp: ComponentType<P>): FC<P> {
  const Observed: FC<P> = (props) => {
    useSignals();
    return <Comp {...props} />;
  };

  Observed.displayName = `Observed(${Comp.displayName ?? Comp.name ?? 'Component'})`;

  return Observed;
}